import Layout from "./layout.js";

import "../styles.scss";

export default () => (
  <Layout>
    <div className="notice">
      Great, you&rsquo;re now subscribed.<br /><br />Thank you!
    </div>
  </Layout>
);
